module.exports = __webpack_public_path__ + "static/media/documentation.1b814d34.md";